import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { getOptionsObject } from '../../utils/api';
import { FETCH_SALARY, fetchSalarySuccess, fetchSalaryError } from './actions';

export const fetchSalary: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_SALARY),
    flatMap(() =>
      ajax(getOptionsObject('/rps/participant-compensation/compensations'))
        .pipe(map((res: any) => fetchSalarySuccess(res.response)))
        .pipe(catchError(ex => of(fetchSalaryError(ex)))),
    ),
  );
